import { render, staticRenderFns } from "./DeliveryMethodSelector.vue?vue&type=template&id=91489bc4&scoped=true"
import script from "./DeliveryMethodSelector.vue?vue&type=script&lang=js"
export * from "./DeliveryMethodSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91489bc4",
  null
  
)

export default component.exports